import React, { Component } from 'react';
import { Promise as BluebirdPromise } from 'bluebird';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm, change, getFormValues, isDirty } from 'redux-form';
import { Form } from 'react-bootstrap';
import { isEmpty, keyBy, get, isUndefined } from 'lodash';
import cns from 'classnames';
import TeamConfirmationModal from './TeamPathway/TeamConfirmationModal';
import MultiCompanyConfirmationModal from './MultiCompanyConfirmationModal';
import CompanyTeamAbout from './CompanyTeamForm/CompanyTeamAbout';
import CompanyTeamResources from './CompanyTeamForm/CompanyTeamResources';
import CompanyTeamMembers from './CompanyTeamForm/CompanyTeamMembers';

import {
    getTeamAdmin,
    postTeamAdmin,
    putTeamAdmin,
    updateTeamMembers,
    postSearchedCompanyMemberProfiles,
    getManyAdminPathways,
    getManyCollections,
    searchForParticipants,
    updateTeamsForUser,
    setUnsavedChanges,
} from '../../../../../shared/actions/index';
import VerbButton, { VERB_BUTTON_TYPE } from '../../../../../shared/components/VerbButton';
import { RuntimeContext } from '../../../../../../common/RuntimeContext';

class CompanyTeamsForm extends Component {
    static propTypes = {
        changeFormValue: PropTypes.func,
        changeSearchFormValue: PropTypes.func,
        getTeamAdmin: PropTypes.func,
        handleSubmit: PropTypes.func.isRequired,
        onExit: PropTypes.func,
        putTeamAdmin: PropTypes.func,
        postTeamAdmin: PropTypes.func,
        onCreateSuccess: PropTypes.func,
        updateTeamMembers: PropTypes.func,
        postSearchedCompanyMemberProfiles: PropTypes.func,
        company: PropTypes.object,
        currentValues: PropTypes.object,
        isNew: PropTypes.bool,
        isVerbAdmin: PropTypes.bool,
        isInstructionalAdmin: PropTypes.bool,
        isAccountOwner: PropTypes.bool,
        mediaMetadata: PropTypes.array,
        teamMembers: PropTypes.array,
        membersById: PropTypes.object,
        team: PropTypes.object,
        teamLeadProfiles: PropTypes.array,
        isContentAdmin: PropTypes.bool,
        invalid: PropTypes.bool,
        dirty: PropTypes.bool,
        toggleShowUnsavedChangesPrompt: PropTypes.func,
        teamTab: PropTypes.string,
        loggedInUserId: PropTypes.string,
        updateTeamsForUser: PropTypes.func,
        featureFlagData: PropTypes.object,
        handleSuccessBannerTeamName: PropTypes.func,
        toggleTeamConfirmationModal: PropTypes.func,
        history: PropTypes.object,
    };

    static contextType = RuntimeContext

    constructor(props) {
        super(props);
        this.state = {
            forceClearSearchSelect: false,
            removeMembersSuccessMessage: '',
            addOrRemoveTeamLeadsSuccessMessage: '',
            saveStatusMessage: '',
            saveError: false,
            updatingMembers: false,
            modalOpen: false,
            modalValue: false,
            selectedTab: props.teamTab || 'about',
            mccModalOpen: false,
            saveAndExit: false,
            defaultMemberSearchOptions: [],
            membersToAdd: [],
            forceClearSearchSelect: false,
            isSaving: false,
        };
    }

    componentDidMount() {
        const useAEN = this.props.featureFlagData.Paths_AEN ?? false;
        const { profiles, loggedInUserId } = this.props
        const tenantId = profiles.byId[loggedInUserId]?.tenantId;


        return searchForParticipants({pathsContext: this.context.pathsWeb, name: '', useAEN, tenantId }).then(res => {
            let defaultOptions = [];
            if (res) {
                defaultOptions = res.results.sort((a, b) => (a.name < b.name ? -1 : 1));
            }
            this.setState({ defaultMemberSearchOptions: defaultOptions });
        });
    }

    componentDidUpdate(prevProps, prevState) {
        const { membersToAdd } = this.state;
        const { setUnsavedChanges } = this.props;
        if (prevProps.dirty !== this.props.dirty) {
            setUnsavedChanges(this.props.dirty);
            return this.props.toggleTeamConfirmationModal(this.props.dirty);
        }
        if (prevState.membersToAdd.length !== membersToAdd.length) {
            setUnsavedChanges(true);
            return this.props.toggleTeamConfirmationModal(true);
        } else if ((membersToAdd.length === 0 && !this.props.dirty)) {
            setUnsavedChanges(false);
            return this.props.toggleTeamConfirmationModal(false);
        }
        return null;
    }
  
    createPermalink = (name) => name.replace(/\s+/g, '-').replace(/&/g, 'and').replace(/\W/g, '').toLowerCase();

    handleAddMembers = async () => {
        const { membersToAdd } = this.state;
        const memberIds = membersToAdd.map((member) => member.value);
        if (!memberIds.length) return null;

        const {
            team: { _id: teamId },
            updateTeamMembers,
            getTeamAdmin,
        } = this.props;

        try {
            const response = await updateTeamMembers({
                teamId,
                action: 'add',
                membersToUpdate: memberIds,
                pathsContext: this.context.pathsWeb
            });

            if (response && Array.isArray(response) && response.length > 0) {
                this.setState({
                    membersToAdd: [],
                    forceClearSearchSelect: true,
                    removeMembersSuccessMessage: ''
                });
            }

            await getTeamAdmin({
                teamId,
                getRegistered: false,
                getAllMembers: true,
                pathsContext: this.context.pathsWeb
            });

            this.updateProfile(response);

            this.setState({forceClearSearchSelect: false});
            this.forceUpdate();

        } catch (error) {
            this.setState({
                addMembersErrorMessage: 'Sorry, something went wrong.'
            })
        }
    };

    handleSave = (exit, isMCC) => async (values) => {
        this.setState({ saveStatusMessage: null, isSaving: true });
        try {
            await this.handleAddMembers();
            const {
                isNew,
                postTeamAdmin,
                onExit,
                company,
                onCreateSuccess,
                changeFormValue,
                isInstructionalAdmin = false,
                isVerbAdmin = false,
                handleSuccessBannerTeamName,
                toggleShowUnsavedChangesPrompt,
                setUnsavedChanges,
            } = this.props;
            const { name, description, isActive, teamLeads, resources, permalink, teamLeadLabel } =
                values;
            const { companyLicenses = [] } = company;
            const body = {
                name,
                description,
                isActive,
                teamLeads,
                resources,
                permalink,
                teamLeadLabel
            };
            const newPermalink = this.createPermalink(values.name);
            changeFormValue({
                field: 'permalink',
                value: newPermalink
            });
            body.permalink = newPermalink;
            values.permalink = newPermalink;
    
            if (isNew) {
                body.parentId = company._id;
                if (isVerbAdmin && companyLicenses.length) {
                    this.setState({ saveAndExit: exit });
                    if (!isUndefined(isMCC)) {
                        body.isMultiCompany = isMCC;
                        this._toggleMCCModal(true);
                    } else {
                        return this._toggleMCCModal(false);
                    }
                }
    
                if (isInstructionalAdmin) body.isMultiCompany = true;
                return postTeamAdmin({ body, pathsContext: this.context.pathsWeb })
                    .then((result) => {
                        setUnsavedChanges(false);
                        return toggleShowUnsavedChangesPrompt(false, () => {
                            if (exit) {
                                handleSuccessBannerTeamName(name, true);
                                return onExit();
                            }
                            return this.setState(
                                {
                                    saveStatusMessage: 'Team created!',
                                    saveError: false,
                                    isSaving: false
                                },
                                () => {
                                    changeFormValue({
                                        field: 'permalink',
                                        value: result.permalink
                                    });
                                    onCreateSuccess(result._id);
                                }
                            );
                        });
                    })
                    .catch((err) => {
                        const errorCode = get(err, 'body.errorCode');
                        if (errorCode === 400.3) {
                            this.setState({
                                saveStatusMessage:
                                    'Team not created. This team name is already in use for this company. Please choose another team name.',
                                saveError: true,
                                isSaving: false
                            });
                        } else {
                            this.setState({
                                saveStatusMessage: 'Sorry, we are unable to create your new team at this time.',
                                saveError: true,
                                isSaving: false
                            });
                        }
                    });
            }
            return this._updateTeam(values)(exit);
        } catch (error) {
            this.setState({
                saveStatusMessage: 'Sorry, we are unable to save your changes at this time.',
                saveError: true,
                isSaving: false
            });
        }
    };

    _toggleModal = () => {
        this.setState((prevState) => { 
            const { modalOpen } = prevState;
            return { modalOpen: !modalOpen };
        });
    };

    _toggleMCCModal = (override) => {
        this.setState((prevState) => {
            const { mccModalOpen } = prevState;
            return { mccModalOpen: override || !mccModalOpen };
        });
    };


    _updateTeam = (values) => (exit) => {
        const { putTeamAdmin, onExit, team, isInstructionalAdmin = false, handleSuccessBannerTeamName, toggleShowUnsavedChangesPrompt } = this.props;
        const {
            name,
            description,
            isActive,
            teamLeads,
            resources,
            permalink,
            teamLeadLabel,
        } = values;

        const body = {
            name,
            description,
            isActive,
            teamLeads,
            resources,
            permalink,
            teamLeadLabel
        };

        this.setState({ saveStatusMessage: null });

        body.revision = team.revision;
        body.parentId = team.parentId;
        body.getRegistered = false;
        if (isInstructionalAdmin) body.isMultiCompany = true;
        return putTeamAdmin({ teamId: team._id, body, getAllMembers: true, pathsContext: this.context.pathsWeb })
            .then(() => {
                setUnsavedChanges(false);
                return toggleShowUnsavedChangesPrompt(false, () => {
                    if (exit) {
                        handleSuccessBannerTeamName(name, true);
                        return onExit();
                    }
                    return this.setState({ saveStatusMessage: 'Changes saved.', saveError: false, isSaving: false });
                });
            })
            .catch((err) => {
                const errorCode = get(err, 'body.errorCode');
                if (errorCode === 400.3) {
                    this.setState({
                        saveStatusMessage:
                            'Error saving team. This team name is already in use for this company. Please choose another team name.',
                        saveError: true,
                        isSaving: false
                    });
                } else {
                    this.setState({
                        saveStatusMessage: 'Error saving team.',
                        saveError: true,
                        isSaving: false
                    });
                }
            });
    };

    checkForValidationError = (callback) => {
        const { invalid } = this.props;
        if (invalid) {
            this.setState({
                saveStatusMessage: 'Error saving team.',
                saveError: true
            });
        } else if (callback) {
            callback();
        }
        return Promise.resolve({});
    };

    updateProfile = (userTeams) => {
        const { profiles, loggedInUserId, updateTeamsForUser } = this.props;

        const filteredTeamData = userTeams.find((teamData) => (teamData._id === loggedInUserId));
        if (!filteredTeamData) return

        const updatedProfile = {
            ...profiles.byId[filteredTeamData._id],
            teams: filteredTeamData.teams
        }

        updateTeamsForUser({profile: updatedProfile})
    }

    handleMemberSelectChange = (values) => {
        this.setState(prevState => ({
            membersToAdd: [...prevState.membersToAdd, values[0]],
            forceClearSearchSelect: false,
        }))
    }

    handleMemberRemoveChange = values => {
        this.setState(prevState => ({
            membersToAdd: values,
        }))
    }

    renderTeamTab = () => {
        const { selectedTab, defaultMemberSearchOptions, membersToAdd } = this.state;
        const {
            changeFormValue,
            company,
            currentValues,
            getTeamAdmin,
            isAccountOwner,
            isContentAdmin,
            isVerbAdmin,
            isInstructionalAdmin,
            mediaMetadata,
            membersById,
            // postSearchedCompanyMemberProfiles,
            teamMembers,
            team,
            teamLeadProfiles,
            updateTeamMembers,
            changeSearchFormValue,
            profiles,
            loggedInUserId
        } = this.props;

        const tenantId = profiles.byId[loggedInUserId]?.tenantId;
        const tabs = {
            about: <CompanyTeamAbout />,
            members: (
                <CompanyTeamMembers
                    changeFormValue={changeFormValue}
                    changeSearchFormValue={changeSearchFormValue}
                    company={company}
                    currentValues={currentValues}
                    getTeamAdmin={getTeamAdmin}
                    isVerbAdmin={isVerbAdmin}
                    membersById={membersById}
                    searchForParticipants={searchForParticipants}
                    // postSearchedCompanyMemberProfiles={postSearchedCompanyMemberProfiles}
                    teamMembers={teamMembers}
                    team={team}
                    teamLeadProfiles={teamLeadProfiles}
                    updateTeamMembers={updateTeamMembers}
                    isInstructionalAdmin={isInstructionalAdmin}
                    defaultMemberSearchOptions={defaultMemberSearchOptions}
                    updateProfile={this.updateProfile}
                    tenantId={tenantId}
                    membersToAdd={membersToAdd}
                    handleMemberSelectChange={this.handleMemberSelectChange}
                    handleRemoveMembersSoftDelete={this.handleRemoveMembersSoftDelete}
                    forceClearSearchSelect={this.state.forceClearSearchSelect}
                    handleMemberRemoveChange={this.handleMemberRemoveChange}
                />
            ),
            resources: (
                <CompanyTeamResources
                    currentValues={currentValues}
                    isAccountOwner={isAccountOwner}
                    isContentAdmin={isContentAdmin}
                    isVerbAdmin={isVerbAdmin}
                    mediaMetadata={mediaMetadata}
                    team={team}
                />
            )
        };

        return tabs[selectedTab];
    };

    render() {
        const { isNew, handleSubmit, onExit } = this.props;

        const { saveStatusMessage, saveError, modalOpen, modalValue, selectedTab, mccModalOpen, saveAndExit } =
            this.state;

        return (
            <Form className={'companyForm company-teams-form col-12'}>
                <div
                    className={'col-sm-12 tabListControl company-tab-list'}
                    style={{ transform: 'translateY(-85px', borderBottom: 'solid 0px', marginBottom: 0 }}
                >
                    <ul className={`col-12 tabList rightTabAlignment`}>
                        <li
                            className={cns({ 'active-tab': selectedTab === 'about' })}
                            onClick={() => this.setState({ selectedTab: 'about' })}
                        >
                            About
                        </li>
                        {!isNew ? (
                            <li
                                className={cns({ 'active-tab': selectedTab === 'members' })}
                                onClick={() => this.setState({ selectedTab: 'members' })}
                            >
                                Members
                            </li>
                        ) : null}
                        {/* <li
                            className={cns({ 'active-tab': selectedTab === 'resources' })}
                            onClick={() => this.setState({ selectedTab: 'resources' })}
                        >
                            Resources
                        </li> */}
                    </ul>
                </div>
                {this.renderTeamTab()}
                <div className={'row col-12 buttons-container'}>
                    <VerbButton
                        fontAwesomeIcon={'fa-save'}
                        textId={'BUTTON_SAVE'}
                        defaultMessage={'SAVE'}
                        onClick={() => {
                            this.checkForValidationError(handleSubmit(this.handleSave(false)));
                        }}
                        disabled={this.state.isSaving}
                    />
                    <VerbButton
                        fontAwesomeIcon={'fa-save'}
                        buttonType={VERB_BUTTON_TYPE.SECONDARY_DEFAULT}
                        textId={'BUTTON_SAVE_AND_EXIT'}
                        defaultMessage={'SAVE & EXIT'}
                        onClick={handleSubmit(this.handleSave(true))}
                        disabled={this.state.isSaving}
                    />
                    <VerbButton
                        buttonType={VERB_BUTTON_TYPE.SECONDARY_DEFAULT}
                        fontAwesomeIcon={'fa-ban'}
                        textId={'BUTTON_CANCEL'}
                        defaultMessage={'CANCEL'}
                        onClick={onExit}
                        disabled={this.state.isSaving}
                    />
                </div>
                <div className={'row me-auto'}>
                    <small className={saveError ? 'error-message' : 'success-message'}> {saveStatusMessage} </small>
                </div>
                <TeamConfirmationModal
                    isOpen={modalOpen}
                    onSubmit={this._updateTeam(modalValue)}
                    toggleModal={this._toggleModal}
                    saveAndExit={saveAndExit}
                />
                <MultiCompanyConfirmationModal
                    isOpen={mccModalOpen}
                    onSubmit={(isMCC) =>
                        this.checkForValidationError(handleSubmit(this.handleSave(saveAndExit, isMCC)))
                    }
                    toggleModal={this._toggleMCCModal}
                />
            </Form>
        );
    }
}

export { CompanyTeamsForm as CompanyTeamsFormComponent };
export const makeMapStateToProps = (state, ownProps) => {
    const {
        team: {
            name,
            description,
            isActive = false,
            teamLeads = [],
            parentId,
            resources,
            members = [],
            teamLeadLabel = 'TEAM_LEAD',
            permalink = '',
            currentAssignedPathway = {},
            teams,
        } = {},
        company = {}
    } = ownProps;
    const {
        auth: { isVerbAdmin, isAccountOwner, isContentAdmin, loggedInUserId }, profiles
    } = state;

    const currentValues = getFormValues('Teams')(state);

    const membersById = keyBy(members, '_id');
    let teamLeadProfiles;

    if (currentValues && currentValues.teamLeads) {
        teamLeadProfiles = currentValues.teamLeads.map((id) => membersById[id]);
    } else {
        teamLeadProfiles = teamLeads.map((id) => membersById[id]);
    }

    const teamMembers = members.filter((member) => member);

    const initialParentId = parentId || company._id;

    return {
        dirty: isDirty('Teams'),
        isVerbAdmin,
        isAccountOwner,
        isContentAdmin,
        currentValues,
        initialValues: {
            name,
            description,
            isActive,
            teamLeads,
            parentId: initialParentId,
            teamLeadsToAdd: [],
            resources,
            teamLeadLabel,
            permalink,
            currentAssignedPathway
        },
        teamMembers,
        membersById,
        teamLeadProfiles,
        company,
        loggedInUserId,
        profiles
    };
};

const CompanyTeamsFormValidation = {
    form: 'Teams',
    destroyOnUnmount: false,
    enableReinitialize: true,
    validate: (values) => {
        const errors = {};
        if (values && values.name) {
            if (!isEmpty(values.name) && values.name.length > 250) {
                errors.name = 'Name is too long';
            }
            if (!values.name || !values.name.length) {
                errors.name = 'Must include a name';
            }
            if (!isEmpty(values.permalink) && !values.permalink.match('^[a-zA-Z0-9-]+$')) {
                errors.permalink = 'Only use letters, numbers, and dashes.';
            }
        }
        return errors;
    }
};

const mapDispatchToProps = (dispatch) => ({
    getTeamAdmin: (params) => dispatch(getTeamAdmin(params)),
    putTeamAdmin: (params) => dispatch(putTeamAdmin(params)),
    postTeamAdmin: (params) => dispatch(postTeamAdmin(params)),
    changeFormValue: (params) => dispatch(change('Teams', params.field, params.value)),
    changeSearchFormValue: (params) => dispatch(change('SearchForm', params.field, params.value)),
    updateTeamMembers: (params) => dispatch(updateTeamMembers(params)),
    postSearchedCompanyMemberProfiles: (params) => dispatch(postSearchedCompanyMemberProfiles(params)),
    getManyAdminPathways: (params) => dispatch(getManyAdminPathways(params)),
    getManyCollections: (params) => dispatch(getManyCollections(params)),
    updateTeamsForUser: (params) => dispatch(updateTeamsForUser(params)), 
    setUnsavedChanges: (params) => dispatch(setUnsavedChanges(params)),
});

export default compose(
    connect(makeMapStateToProps, mapDispatchToProps),
    reduxForm(CompanyTeamsFormValidation)
)(CompanyTeamsForm);
